// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26joG","top":"styles_top__3qAD8","left":"styles_left__c2aCh","description":"styles_description__2cMPX"};